module.exports = __webpack_public_path__ + "static/media/female-avatar.53af86a5.svg";